export default __webpack_public_path__ + "static/basics_sun_header-cdd92d5c69ff319e839bc7e1b5a615da.png";